/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_GestionOrganigrama as GestionOrganigrama,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_puedeOrganigrama as puedeOrganigrama,
} from "../../runtime/index.jsx";
export function Organigrama() {
  let e = (0, ReactCompiler.c)(2);
  if (!puedeOrganigrama()) {
    let t;
    return (
      e[0] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((t = <AccesoDenegado />), (e[0] = t))
        : (t = e[0]),
      t
    );
  }
  let t;
  return (
    e[1] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((t = (
          <EstructuraPrincipal
            title={`Organigrama`}
            accionesRapidas={!1}
            children={<GestionOrganigrama />}
          />
        )),
        (e[1] = t))
      : (t = e[1]),
    t
  );
}
